/** Pure reducers for the lyric-stage iframe host. Kept separate so React setState loops can be tested without a DOM. */

export function resolvePaused(value: unknown): boolean {
  return Boolean(value)
}

/** Return the next paused flag, or null when React state must not update. */
export function nextPausedState(prevPaused: boolean, tickPaused: unknown): boolean | null {
  const paused = resolvePaused(tickPaused)
  return prevPaused === paused ? null : paused
}

/**
 * Child iframe announces READY once at boot so the parent can send SESSION_INIT.
 * Echoing READY after SESSION_INIT makes the parent send SESSION_INIT again (ping-pong).
 */
export function shouldAnnounceReadyAfterSessionInit(): boolean {
  return false
}
